import { Link } from "@tanstack/react-router";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHOTO_SIZES, PHOTOS } from "./images";
import { ACTIVITIES_PATH, routeTo, TOUR_360_URL } from "@/lib/site";

export function FalconLakeFeature() {
  const photo = PHOTOS.cabinRow;

  return (
    <section
      className="relative isolate overflow-hidden bg-forest-deep py-28 sm:py-36 lg:py-44"
      aria-labelledby="falcon-title"
    >
      <div className="absolute inset-x-0 -top-[8%] -z-10 h-[116%]" aria-hidden="true">
        <img
          src={photo.src}
          srcSet={photo.srcSet}
          sizes={PHOTO_SIZES.fullBleed}
          alt=""
          width={photo.width}
          height={photo.height}
          loading="lazy"
          decoding="async"
          className="size-full object-cover"
        />
      </div>
      <div
        className="absolute inset-0 -z-10 bg-[linear-gradient(100deg,oklch(0.259_0.042_163.6/0.94)_0%,oklch(0.259_0.042_163.6/0.72)_55%,oklch(0.259_0.042_163.6/0.5)_100%)]"
        aria-hidden="true"
      />

      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <Reveal className="max-w-2xl text-cream">
          <p className="eyebrow text-sand">Fishing, Boating and South Texas Adventure</p>
          <h2
            id="falcon-title"
            className="mt-5 text-balance font-display text-3xl leading-[1.1] sm:text-4xl lg:text-[3.1rem]"
          >
            Close to Falcon Lake. Connected to Everything Zapata Offers.
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-cream/85 sm:text-lg">
            <p>
              Falcon Lake is known throughout the fishing community, and Amigo Inn sits close to
              public boat access — so mornings on the water start early and end back at your site.
            </p>
            <p>
              Beyond the lake, Zapata offers South Texas culture, authentic food, seasonal events
              and county fair weekends, plus convenient access to Laredo, Rio Grande City and the
              wider Rio Grande Valley.
            </p>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-x-8 gap-y-4">
            <Link
              to={routeTo(ACTIVITIES_PATH)}
              className="link-underline text-sm font-semibold text-cream"
            >
              Explore Activities <ArrowRight className="size-4" aria-hidden="true" />
            </Link>
            {/* TODO: verify 360° tour URL before production deployment */}
            <a
              href={TOUR_360_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="link-underline text-sm font-semibold text-sand"
            >
              Take the 360° Tour <ArrowUpRight className="size-4" aria-hidden="true" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
